import React from "react";
import { Globe, AtSign, Newspaper, Star, Sparkles, ExternalLink } from "lucide-react";

const MAP = {
  official_website: { label: "Official site", icon: Globe, cls: "text-emerald-700 bg-emerald-50 border-emerald-200" },
  official_social: { label: "Official social", icon: AtSign, cls: "text-blue-700 bg-blue-50 border-blue-200" },
  third_party: { label: "Third-party", icon: Newspaper, cls: "text-slate-700 bg-slate-100 border-slate-200" },
  review: { label: "Customer reviews", icon: Star, cls: "text-amber-700 bg-amber-50 border-amber-200" },
  ai_inference: { label: "AI inference", icon: Sparkles, cls: "text-blue-700 bg-transparent border-dashed border-blue-300" },
};

export function ProvenanceBadge({ type, size = "sm" }) {
  const t = MAP[type] || MAP.third_party;
  const Icon = t.icon;
  const pad = size === "xs" ? "text-[9px] px-1.5 py-0.5" : "text-[10px] px-2 py-0.5";
  return (
    <span data-testid={`provenance-badge-${type || "third_party"}`}
      className={`inline-flex items-center gap-1 font-mono font-semibold rounded border ${pad} ${t.cls}`}>
      <Icon className="w-2.5 h-2.5" /> {t.label}
    </span>
  );
}

export function ProvenanceLegend() {
  return (
    <div className="flex flex-wrap gap-2" data-testid="provenance-legend">
      {Object.keys(MAP).map((k) => <ProvenanceBadge key={k} type={k} />)}
    </div>
  );
}

export function SourceLink({ url, className = "" }) {
  if (!url) return null;
  return (
    <a href={url} target="_blank" rel="noreferrer" className={`inline-flex items-center gap-1 text-xs text-blue-700 hover:underline ${className}`}>
      source <ExternalLink className="w-3 h-3" />
    </a>
  );
}
